const DANGEROUS_KEYS = new Set(['__proto__', 'prototype', 'constructor']);
const MAX_IMPORT_BYTES = 5 * 1024 * 1024;

function assertSafe(value, depth = 0) {
  if (depth > 80) throw new Error('Project nesting is too deep.');
  if (!value || typeof value !== 'object') return;
  for (const key of Object.keys(value)) {
    if (DANGEROUS_KEYS.has(key)) throw new Error(`Unsafe project key: ${key}`);
    assertSafe(value[key], depth + 1);
  }
}

export function parseSafeJson(text) {
  if (new Blob([text]).size > MAX_IMPORT_BYTES) throw new Error('Project file exceeds the 5 MB safety limit.');
  const data = JSON.parse(text, (key, value) => {
    if (DANGEROUS_KEYS.has(key)) throw new Error(`Unsafe project key: ${key}`);
    return value;
  });
  assertSafe(data);
  return data;
}

export function stringifyProject(data) {
  assertSafe(data);
  return JSON.stringify(data, null, 2);
}
